import { useDispatch, useSelector } from "react-redux"

const useCheckInStudentModal = () => {
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.dashboard.checkInStudent)
    const {isOpen} = reduxData
    const setData = (isOpen = false, onChange = () => {}, student = {}, reason, description = '', text = '') => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'dashboard.checkInStudent',
            data: {
                ...reduxData,
                isOpen,
                onChange,
                student,
                reason,
                description,
                text,
                
            }
        })
    }

    const closeDelay = () => {
        setData(false, reduxData?.onChange, reduxData?.student, reduxData?.reason, reduxData.description, reduxData?.text)
        setTimeout(() => {
            setData(false)
        }, 5000)
    }
    return {
        ...reduxData,
        open: (onChange = () => {}, student = {}, reason = 'homework', description = '', text = '') => {
            setData(true, onChange, student, reason, description, text)
        },
        close: closeDelay,
        toggle: () => {
            if(isOpen) closeDelay()
            else setData(!isOpen)
        },
    }
}

export default useCheckInStudentModal